import { render, staticRenderFns } from "./AudioChannel.vue?vue&type=template&id=087ed59e&scoped=true&"
import script from "./AudioChannel.vue?vue&type=script&lang=js&"
export * from "./AudioChannel.vue?vue&type=script&lang=js&"
import style0 from "./AudioChannel.vue?vue&type=style&index=0&id=087ed59e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087ed59e",
  null
  
)

export default component.exports